import * as types from "../../_constants/types";

export default (state = { loading: false }, action) => {
    switch (action.type) {
        case types.ORDER_CANCEL_FETCHING:
            return { loading: true };

        case types.ORDER_CANCEL_FETCHING_COMPLETED:
            return { loading: false };

        case types.ORDER_CANCEL_FETCHING_FAILED:
            return { loading: false, err: action.err };

        default:
            return state;
    }
};
